import { KeyButton } from '../../../keyButton/KeyButton'
import './HotkeyHint.css'

export interface HotkeyHintProps {
	key: string | number,
	translation: string,
	buttons: string[]
}

export const HotkeyHint = ({ key, translation, buttons }: HotkeyHintProps) => {
	return (
		<div className="hotkey-hint" key={key}>
			<p>{translation}</p>
			<KeyButton text={buttons.join(' + ')} />
		</div>
	)
}